<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div name="tab-container" class="tab-container small base">
            <div class="tabs-nav">
                <ul class="head">
                    <li v-for="item in tabList" :class="{'current': item.value == checkValue}" class="head-item" @click="tabChange(item.value)">
                        <span>{{item.text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import { getDefaultPageSizes } from '../../app.conf'

    import comnApi from '../../api/comn'
    import goodsApi from '../../api/goods'
    import shopDevcApi from '../../api/devc'

    export default {
        name: 'swb-brand-list-for-select',
        desc: '品牌选择组件',
        props: {
            checkBox: {
                type: Boolean,
                default: false
            },
            selectIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            catId: {
                type: Number,
                default: null
            },
            deleted: {
                type: Boolean,
                default: null
            },
            showAll: {
                type: Boolean,
                default: true
            },
            currentCheckValue: {    // 仅展示某一页签
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                confKey: 'swb-brand-list-for-select',
                theTableHeight: 510,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "brandId", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: true, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                tabList: [{
                    value: 0,
                    text: '资产型号品牌'
                }, {
                    value: 1,
                    text: '平台商品品牌'
                }, {
                    value: 2,
                    text: '分类品牌'
                }, {
                    value: 3,
                    text: '全部'
                }],
                checkValue: 0,
                brandList: []
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.multiSelect = this.checkBox;
            this.multiPageSelect = this.checkBox;
            //
            if(!Utils.isNoB(this.currentCheckValue)) {
                this.tabList = [];
                //
                this.checkValue = this.currentCheckValue;
            } else {
                if(!Utils.isNoB(this.catId) && Utils.isFalse(this.showAll)) {
                    let tabList = [{
                        value: 0,
                        text: '资产型号品牌'
                    }, {
                        value: 1,
                        text: '平台商品品牌'
                    }, {
                        value: 2,
                        text: '分类品牌'
                    }];
                    //
                    this.tabList = Utils.merge([], tabList);
                }
            }
        },
        mounted() {
            //
            this.initResultTable();
            //回显数据处理
            let initChecked = this.selectIds;
            let resultTable = this.$refs.result_table;
            resultTable.setInitChecked(initChecked, false);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'actions': function (row, colName, colValue, rowIndex) {
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            // 页签切换
            tabChange: function (val) {
                this.pageNumber = 1;
                this.checkValue = val;
                this.getBrandList();
            },
            //
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getBrandList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getBrandList();
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            getBrandList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if(!Utils.isNoB(self.catId)) {
                    filterItems.catId = self.catId;
                }
                if(!Utils.isNoB(self.deleted)) {
                    filterItems.deleted = self.deleted;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                if(!Utils.isNoB(self.checkValue) && self.checkValue == 0) {
                    // 调用查询接口
                    shopDevcApi.getShopDeviceBrandList(postData, function (result) {
                        theLoading.close();
                        if(result.type == 'info') {
                            let resultData = result.data;
                            if(!Utils.isNoB(resultData)) {
                                self.brandList = resultData.rows;
                                let pagination = resultData.pagination;
                                self.totalCount = pagination.totalCount;
                                self.pageNumber = pagination.pageNumber;
                                self.pageSize = pagination.pageSize;
                                self.renderTable(self.brandList, resultData.pagination);
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else if(!Utils.isNoB(self.checkValue) && self.checkValue == 1) {
                    // 调用查询接口
                    goodsApi.getGoodsBrandList(postData, function (result) {
                        theLoading.close();
                        if(result.type == 'info') {
                            let resultData = result.data;
                            if(!Utils.isNoB(resultData)) {
                                self.brandList = resultData.rows;
                                let pagination = resultData.pagination;
                                self.totalCount = pagination.totalCount;
                                self.pageNumber = pagination.pageNumber;
                                self.pageSize = pagination.pageSize;
                                self.renderTable(self.brandList, resultData.pagination);
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else if(!Utils.isNoB(self.checkValue) && self.checkValue == 2) {
                    comnApi.getBrandPagedList(postData, function (result) {
                        theLoading.close();
                        if(result.type === "info") {
                            let resultData = result.data;
                            if(!Utils.isNoB(resultData)) {
                                self.brandList = result.data.rows;
                                //
                                let pagination = result.data.pagination;
                                self.totalCount = pagination.totalCount;
                                self.pageNumber = pagination.pageNumber;
                                self.pageSize = pagination.pageSize;
                                self.renderTable(self.brandList, result.data.pagination);
                            }
                        } else {
                            self.$message.error(result.message);
                        }
                    });
                } else if(!Utils.isNoB(self.checkValue) && self.checkValue == 3) {
                    if(!Utils.isNoB(self.catId)) {
                        filterItems.catId = null;
                    }
                    comnApi.getBrandPagedList(postData, function (result) {
                        theLoading.close();
                        if(result.type === "info") {
                            let resultData = result.data;
                            if(!Utils.isNoB(resultData)) {
                                self.brandList = result.data.rows;
                                //
                                let pagination = result.data.pagination;
                                self.totalCount = pagination.totalCount;
                                self.pageNumber = pagination.pageNumber;
                                self.pageSize = pagination.pageSize;
                                self.renderTable(self.brandList, result.data.pagination);
                            }
                        } else {
                            self.$message.error(result.message);
                        }
                    });
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDlgResult: function () {
                let selectList = this.getTableSelection() || [];
                //
                let result = {};
                if(selectList.length <= 0) {
                    result.type = "warn";
                    if(Utils.isTrue(this.checkBox)) {
                        result.message = "请选择至少一个品牌！";
                    } else {
                        result.message = "请选择品牌！";
                    }
                } else {
                    result.type = "info";
                    result.data = selectList;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/BrandListForSelect.vue